module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/accessibility-keyboard/accessibility-keyboard.component.css
// module id = ./src/app/examples/accessibility-keyboard/accessibility-keyboard.component.css
// module chunks = main